/* Robotow page wiring: fit finders and video plates.
   Analytics go through window.rtTrack (assets/rt-events.js) with the names in the tracking plan.
   Everything renders without this file except the fit answer itself. */
(function () {
  "use strict";

  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function track(name, params) { if (typeof window.rtTrack === "function") window.rtTrack(name, params); }
  function trackOnce(key, name, params) { if (typeof window.rtTrackOnce === "function") window.rtTrackOnce(key, name, params); }

  /* ---------- fit finders ---------- */
  function countsLine(el) {
    var Fit = window.RobotowFit, d = Fit && Fit.data();
    var tpl = el.getAttribute("data-template");
    if (!d || !tpl) return;
    el.textContent = tpl
      .replace("[fits]", d.counts.listed)
      .replace("[confirm]", d.counts.confirm)
      .replace("[no_fit]", d.counts.no_fit);
    el.hidden = false;
  }

  function selected(a, matchType, entry) {
    var Fit = window.RobotowFit;
    if (typeof window.rtRememberAircraft === "function") window.rtRememberAircraft(a.id);
    track("rt_aircraft_selected", {
      aircraft_id: a.id,
      aircraft_make: Fit.makeOf(a),
      match_type: matchType,
      entry_point: entry,
      follow_up_required: !!(a.follow_up && a.follow_up.answers && a.follow_up.answers.length)
    });
  }

  // Never send what the visitor typed (it can be an N-number, a name or an email). Entry point only.
  function noMatchSeen(q, entry) {
    track("rt_selector_no_match", { entry_point: entry });
  }

  function initResolve(root, index) {
    var Fit = window.RobotowFit;
    var result = root.querySelector("[data-rt-result]");
    var entry = root.getAttribute("data-entry") || "section";

    var emit = root.hasAttribute("data-rt-emit");

    function show(a, ans) {
      var state = Fit.classify(a);
      if (emit && state !== "nomatch") {
        result.innerHTML = "";
        root.classList.remove("has-result");
        root.dispatchEvent(new CustomEvent("rt:aircraft", { bubbles: true, detail: { aircraft: a } }));
      } else {
        result.innerHTML = Fit.buildResultHTML(a, { fu: ans && ans.id ? ans.id : "" });
        root.classList.add("has-result");
      }
      if (state === "nomatch") return;
      var kit = a.adapter ? Fit.findKit(a.unit, "5Ah", a.adapter) : null;
      var fr = Fit.resultName(state);
      trackOnce("fit:" + a.id + ":" + fr, "rt_fit_result_shown", {
        aircraft_id: a.id,
        aircraft_make: Fit.makeOf(a),
        fit_result: fr,
        adapter_pn: a.adapter || "",
        frame: a.unit || "",
        kit_price: kit && kit.price ? kit.price / 100 : null,
        entry_point: entry
      });
    }

    function resolve(a, matchType) {
      selected(a, matchType, entry);
      if (a.follow_up && a.follow_up.answers && a.follow_up.answers.length) {
        // Move focus to the question only when the pilot picked the airplane here, never on a deep link
        // (an ad click must land at the top of the page).
        if (matchType === "url_param") result.removeAttribute("data-rt-focus"); else result.setAttribute("data-rt-focus", "");
        Fit.renderFollowUpChips(result, a, function (resolved, ans) {
          track("rt_follow_up_answered", {
            aircraft_id: a.id,
            question_id: a.follow_up.id || "",
            answer_id: (ans && ans.id) || "",
            entry_point: entry
          });
          show(resolved, ans);
        });
        root.classList.add("has-result");
        return;
      }
      show(a);
    }

    var widget = new window.RobotowSelector(root, {
      mode: "resolve",
      onSelect: resolve,
      onNoMatch: function (typed) {
        result.innerHTML = Fit.buildResultHTML(null, { typed: typed });
        root.classList.add("has-result");
      },
      onNoMatchSeen: function (q) { noMatchSeen(q, entry); }
    });
    release(root, widget);

    result.addEventListener("click", function (e) {
      var t = e.target.closest("[data-rt-restart]");
      if (!t) return;
      result.innerHTML = "";
      root.classList.remove("has-result");
      widget.input.value = "";
      widget.input.focus();
    });

    // Deep links: ?ac=<handle> resolves an airplane (redirect map, header search),
    // ?q=<text> types it in (manufacturer-level redirects). First finder on the page only.
    if (index === 0) {
      var params = new URLSearchParams(window.location.search);
      var ac = params.get("ac"), q = params.get("q");
      if (!ac && !q) {
        try { q = sessionStorage.getItem("rt_q"); sessionStorage.removeItem("rt_q"); } catch (e) { q = null; }
      }
      if (ac) {
        var a = Fit.getAircraft(ac);
        var fu = params.get("fu");
        var given = null;
        if (a && fu && a.follow_up && a.follow_up.answers) {
          for (var i = 0; i < a.follow_up.answers.length; i++) if (a.follow_up.answers[i].id === fu) given = a.follow_up.answers[i];
        }
        if (a && given) {
          // The pilot already answered this question on the page before: apply it, do not ask again.
          widget.input.value = a.display;
          selected(a, "url_param", entry);
          show(Fit.resolveAnswer(a, given), given);
        } else if (a) { widget.input.value = a.display; resolve(a, "url_param"); }
      } else if (q) {
        widget.input.value = q;
        widget.render();
      }
    }
  }

  // Until the fit data arrives, a submit is held (never sent to the server with the text in the URL),
  // then answered once the data is in.
  function guardFinders() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-rt-fit-finder] form"), function (form) {
      form.addEventListener("submit", function (e) {
        if (form.__rtReady) return;
        e.preventDefault();
        if (form.__rtPending) return;
        form.__rtPending = true;
        // data never arrived: fall back to the full list (the form carries no text)
        setTimeout(function () {
          if (form.__rtReady) return;
          form.__rtReady = true;
          form.submit();
        }, 8000);
      });
    });
  }
  function release(root, widget) {
    var form = root.querySelector("form");
    if (!form) return;
    form.__rtReady = true;
    if (form.__rtPending) { form.__rtPending = false; widget.submitTyped(); }
  }

  function initFinders() {
    var Fit = window.RobotowFit;
    if (!Fit || !window.RobotowSelector) return;
    guardFinders();
    Fit.ready(function () {
      var cfg = Fit.config();
      Array.prototype.forEach.call(document.querySelectorAll("[data-rt-counts]"), countsLine);
      Array.prototype.forEach.call(document.querySelectorAll('[data-rt-fit-finder="resolve"]'), initResolve);
      Array.prototype.forEach.call(document.querySelectorAll('[data-rt-fit-finder="redirect"]'), function (root) {
        // With a resolving finder on this page, the header search answers in place.
        var local = document.querySelector('[data-rt-fit-finder="resolve"]');
        var entry = root.getAttribute("data-entry") || "header";
        if (local) {
          release(root, new window.RobotowSelector(root, {
            mode: "redirect",
            redirectPath: window.location.pathname,
            redirectHash: "#" + (local.id || ""),
            onNoMatchSeen: function (q) { noMatchSeen(q, entry); }
          }));
          return;
        }
        release(root, new window.RobotowSelector(root, {
          mode: "redirect",
          redirectPath: cfg.redirectPath || "/",
          redirectHash: cfg.redirectHash || "",
          onSelect: function (a, via) { selected(a, via, entry); },
          onNoMatchSeen: function (q) { noMatchSeen(q, entry); }
        }));
      });
    });
  }

  /* ---------- video plates ---------- */
  function motionChoice(val) {
    try {
      if (val) localStorage.setItem("rt_motion", val);
      return localStorage.getItem("rt_motion");
    } catch (e) { return null; }
  }

  // A plate with two sources (data-src and data-src-wide) gets only the file for this screen; it is hidden
  // until frames actually play, so the poster still underneath shows while loading and under reduced motion.
  function pickSource(v, wrap) {
    var narrow = v.getAttribute("data-src");
    if (!narrow) return;
    var wide = v.getAttribute("data-src-wide");
    var mq = window.matchMedia ? window.matchMedia("(min-width: " + (v.getAttribute("data-wide-from") || 990) + "px)") : null;
    function live(on) { if (wrap) wrap.classList.toggle("is-live", on); }
    function apply() {
      var want = wide && mq && mq.matches ? wide : narrow;
      if (v.getAttribute("src") === want) return;
      var resume = !v.paused;
      live(false);
      v.setAttribute("src", want);
      if (resume) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    v.addEventListener("playing", function () { live(true); });
    v.addEventListener("emptied", function () { live(false); });
    apply();
    if (mq) {
      if (mq.addEventListener) mq.addEventListener("change", apply);
      else if (mq.addListener) mq.addListener(apply);
    }
  }

  function initVideos() {
    var vids = document.querySelectorAll("video[data-rt-autoplay]");
    var userPaused = motionChoice() === "paused";
    // 200px lookahead so a clip is already fetching by the time it scrolls into view, not
    // starting cold on the frame it crosses the threshold.
    var io = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (v.getAttribute("data-rt-paused-by-user") === "1" || reduced) return;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.15, rootMargin: "200px 0px" }) : null;

    // Nothing here fetches a frame of video until the page has actually loaded: picking a
    // source (which sets the real src on a preload="none" video) and handing the player to the
    // IntersectionObserver both wait for `start`, so the LCP candidate never shares bandwidth
    // with a film-strip clip or a below-fold poster. `load` can be held up by a slow third
    // party, so a 3s fallback fires regardless.
    var started = false;
    function startOne(v) {
      pickSource(v, v.closest("[data-rt-plate]"));
      var dataPoster = v.getAttribute("data-poster");
      if (dataPoster) { v.poster = dataPoster; v.removeAttribute("data-poster"); }
      if (reduced || userPaused) { v.pause(); v.setAttribute("data-rt-paused-by-user", "1"); }
      if (io) io.observe(v);
      else if (!reduced) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }
    function start() {
      if (started) return;
      started = true;
      Array.prototype.forEach.call(vids, startOne);
    }
    if (document.readyState === "complete") start();
    else window.addEventListener("load", start);
    setTimeout(start, 3000);

    Array.prototype.forEach.call(vids, function (v) {
      v.muted = true;
      var wrap = v.closest("[data-rt-plate]");
      // the home hero has a second control on its kicker row (phones); both drive the same video
      var btns = wrap ? (v.closest(".rt-hero") || wrap).querySelectorAll("[data-rt-playpause]") : [];
      if (!btns.length) return;
      function sync() {
        var paused = v.paused;
        Array.prototype.forEach.call(btns, function (btn) {
          if (btn.hasAttribute("aria-pressed")) btn.setAttribute("aria-pressed", paused ? "true" : "false");
          btn.querySelector("[data-label]").textContent = paused ? btn.getAttribute("data-play") : btn.getAttribute("data-pause");
          btn.classList.toggle("is-paused", paused);
        });
        wrap.classList.toggle("is-paused", paused);
      }
      v.addEventListener("play", sync);
      v.addEventListener("pause", sync);
      Array.prototype.forEach.call(btns, function (btn) { btn.addEventListener("click", toggle); });
      function toggle() {
        if (v.paused) {
          start(); // a direct tap to play means now, even if `load` hasn't fired yet
          v.setAttribute("data-rt-paused-by-user", "0");
          motionChoice("on");
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          var src = (v.currentSrc || (v.querySelector("source") || {}).src || "").split("/").pop().split("?")[0];
          trackOnce("video:" + src, "rt_video_play", { video_name: src, entry_point: v.closest(".rt-hero") ? "home_hero" : "page" });
        } else {
          v.setAttribute("data-rt-paused-by-user", "1");
          motionChoice("paused");
          v.pause();
        }
      }
      sync();
    });
  }

  function start() { initFinders(); initVideos(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* NEWOWNER letter visitors: the Batch 01 letter QR codes open the plain landing page (no discount link).
   When the URL carries utm_source=lob and a utm_campaign starting with new-owner-, put the code on the cart
   (keeping any code the shopper already has). End date 2027-03-31 23:59:59 ET, as the discount.
   Once per page load, silent on any error. */
(function () {
  "use strict";
  /* keep UNTIL identical in assets/rt-kit.js and the other NEWOWNER block */
  var CODE = "NEWOWNER", UNTIL = Date.parse("2027-04-01T03:59:59Z");
  try {
    var q = new URLSearchParams(window.location.search);
    if (q.get("utm_source") !== "lob" || String(q.get("utm_campaign") || "").indexOf("new-owner-") !== 0) return;
    if (Date.now() >= UNTIL) return;
    fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return String(d.code); });
        if (codes.some(function (c) { return c.toUpperCase() === CODE; })) return;
        codes.push(CODE);
        return fetch("/cart/update.js", {
          method: "POST", credentials: "same-origin", keepalive: true,
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: codes.join(",") })
        });
      })
      .catch(function () {});
  } catch (e) {}
})();
